import { createServerFn } from "@tanstack/react-start";
import z from "zod";
import {
  getTranslation as getTranslationFromDb,
  getTranslations as getTranslationsFromDb,
} from "~/lib/translations";

export const getTranslation = createServerFn({ method: "GET" })
  .inputValidator(
    z.object({
      namespace: z.string(),
      key: z.string(),
      language: z.number().optional(),
    }),
  )
  .handler(async (ctx) => {
    const { namespace, key, language = 0 } = ctx.data;
    return getTranslationFromDb(namespace, key, language);
  });

export const getTranslations = createServerFn({ method: "GET" })
  .inputValidator(
    z.object({
      namespace: z.string(),
      keys: z.array(z.string()),
      language: z.number().optional(),
    }),
  )
  .handler(async (ctx) => {
    const { namespace, keys, language = 0 } = ctx.data;
    return getTranslationsFromDb(namespace, keys, language);
  });
